'use client';

import type { Table } from '@/lib/table-features';
import { useTranslations } from 'next-intl';
import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Registration } from '@/features/registration';

interface StickingTableActionBarProps {
  table: Table<Registration>;
  isAllPagesSelected: boolean;
  totalCount: number;
}

export function StickingTableActionBar({
  table,
  isAllPagesSelected,
  totalCount
}: StickingTableActionBarProps) {
  const t = useTranslations('sticking');

  const selectedRows = table.getFilteredSelectedRowModel().rows;
  const selectedCount = isAllPagesSelected ? totalCount : selectedRows.length;

  if (selectedCount === 0) return null;

  return (
    <div className='bg-muted flex items-center gap-3 rounded-lg px-4 py-2'>
      <span className='text-muted-foreground text-sm font-medium'>
        {t('selectedCount', { count: selectedCount })}
      </span>
      <div className='flex items-center gap-2'>
        <Button variant='outline' size='sm'>
          <Eye className='me-1.5 h-3.5 w-3.5' />
          {t('viewSelected')}
        </Button>
      </div>
    </div>
  );
}
